// ReviewStars component
"use client";

import React from 'react';
import { Rating, ThinStar } from '@smastrom/react-rating';
import { shadeColor } from "@/lib/utils";

interface ReviewStarsProps {
  count: number;
  rating: number;
  hexColour: string;
  textColour: string;
}

const ReviewStars: React.FC<ReviewStarsProps> = ({ count, rating, hexColour, textColour }) => {
  const myStyles = {
    itemShapes: ThinStar,
    activeFillColor: hexColour,
    inactiveFillColor: shadeColor(hexColour, 50)
  };
  return (
    <div className="flex flex-col items-center justify-center w-full my-4 mt-8">
      <div className="flex items-center justify-center w-1/2">
      <Rating
        className="mt-1"
        style={{ maxWidth: 250 }}
        value={rating}
        readOnly
        halfFillMode='svg'
        itemStyles={myStyles}
      />
      </div>
      {/* If count is one show review else reviews */}
      <p className="flex mt-2 text-xl font-bold leading-5 text-center mx-4" style={{color: textColour}}>{count} review{count != 1 ? 's' : ''}</p>
    </div>
  );
};

export default ReviewStars;


